import React from 'react';

const ErrorText = ({ error }) => error ? <span className="text-danger">{error}</span> : null

export default ErrorText;